import React, { createContext, useContext, useEffect, useState } from 'react';
import { Drawer } from 'antd';
import { NavLink } from 'react-router-dom';

export const NavigationContext = createContext({ mobile: false, expanded: true, toggle: () => {}, close: () => {} });

export function NavigationProvider({ children }) {
    const [mobile, setMobile] = useState(() => window.matchMedia('(max-width: 1199px)').matches);
    const [collapsed, setCollapsed] = useState(false);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        const media = window.matchMedia('(max-width: 1199px)');
        const update = () => { setMobile(media.matches); setOpen(false); };
        media.addEventListener('change', update);
        return () => media.removeEventListener('change', update);
    }, []);
    return <NavigationContext.Provider value={{ mobile, expanded: mobile ? open : !collapsed, toggle: () => mobile ? setOpen(value => !value) : setCollapsed(value => !value), close: () => setOpen(false) }}>
        <div className="admin-app" data-sidebar-collapsed={!mobile && collapsed}>{children}</div>
    </NavigationContext.Provider>;
}

const items = [
    ['/analytics', 'System Analytics', 'line-chart'],
    ['/map-dashboard', 'Map Dashboard', 'globe'],
    ['/scoreboard', 'Scoreboard', 'trophy'],
    ['/users', 'Users', 'users'],
    ['/labs', 'Labs', 'flask'],
    ['/categories', 'Analysis Category', 'sitemap'],
    ['/tests', 'Type of Analysis', 'archive'],
    ['/coc-types', 'COC Types', 'tags'],
];

export default function SideMenu() {
    const { mobile, expanded, close } = useContext(NavigationContext);
    const links = <nav aria-label="Main navigation"><ul className="nav nav-sidebar">{items.map(([path, label, icon]) =>
        <li key={path} className="sidebar-nav-item"><NavLink to={path} className="sidebar-nav-link" activeClassName="active" onClick={close}><i className={`fa fa-${icon}`} aria-hidden="true" /><span>{label}</span></NavLink></li>
    )}</ul></nav>;
    return mobile ? <Drawer title="Navigation" placement="left" width={280} open={expanded} onClose={close} rootClassName="admin-navigation-drawer" styles={{ body: { padding: 12 } }}>
        <div id="admin-navigation">{links}</div>
    </Drawer> : <aside id="admin-navigation" className="slim-sidebar" hidden={!expanded}>
        <div className="sidebar-label">Workspace</div>{links}
    </aside>;
}
